import { VerificationRequestStatus } from '../../api/api-clients';

// Readable mapping of backend VerificationRequestStatus enum
export enum AppVerificationRequestStatus {
  Pending = 'Pending',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Paid = 'Paid',
  Gift = 'Gift',
}

const STATUS_MAP: Record<VerificationRequestStatus, AppVerificationRequestStatus> = {
  [VerificationRequestStatus._0]: AppVerificationRequestStatus.Pending,
  [VerificationRequestStatus._1]: AppVerificationRequestStatus.Approved,
  [VerificationRequestStatus._2]: AppVerificationRequestStatus.Rejected,
  [VerificationRequestStatus._3]: AppVerificationRequestStatus.Paid,
  [VerificationRequestStatus._4]: AppVerificationRequestStatus.Gift,
};

export interface AppVerificationRequest {
  id: string;
  status: AppVerificationRequestStatus;
  requestedAt: Date;
  reviewedAt?: Date;
  reviewerNote?: string;
}

export function toAppVerificationRequest(raw: { id?: string; status?: VerificationRequestStatus; requestedAt?: Date; reviewedAt?: Date; reviewerNote?: string }): AppVerificationRequest {
  return {
    id: raw.id!,
    status: raw.status != null ? STATUS_MAP[raw.status] : AppVerificationRequestStatus.Pending,
    requestedAt: raw.requestedAt!,
    reviewedAt: raw.reviewedAt,
    reviewerNote: raw.reviewerNote,
  };
}
